import { useStaticQuery, graphql } from "gatsby"

// return an id-based object of all questions and answers,
// with question ids as keys
// {
// 	1: {question: 'question', answers: ['answer1', 'answer2'], id: '1'},
// 	2: {question: 'question', answers: ['answer, 'answer2'], id: '2'}
// }
export const useQuestionData = () => {
  const data = useStaticQuery(graphql`
    {
      allQuestionsJson {
        edges {
          node {
            title
            display
            question_id
            answers {
              id
              title
            }
          }
        }
      }
    }
  `)

  const formattedData = data.allQuestionsJson.edges.reduce((obj, item) => {
    obj[item.node.question_id] = item.node
    return obj
  }, {})

  return formattedData
}
